module.exports = __webpack_public_path__ + "static/images/drag-handle.c22384d7fd1d50ed6e3fad4c6e2aa7c3.svg";